// SignaturePadComponent.js
import { Alert, Button, Col, Flex, Row, Upload, message, theme, notification } from 'antd';
import { EditOutlined, LeftOutlined, DeleteOutlined, VideoCameraOutlined, InboxOutlined, InfoCircleOutlined, RightOutlined } from '@ant-design/icons';
import React, { useRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import SignatureSettingsAPI from '../../../restAPI/SignatureSettingsAPI';
import useCurrentCompany from '../../../hooks/useCurrentCompany';

const { Dragger } = Upload;

const UploadSignature = ({goBack}) => {
    const { companyId, token, userCompany } = useSelector(state => state.auth);
    const [file, setFile] = useState();
    const [fileName, setFileName] = useState();    
    const currentCompanyInfo = useCurrentCompany();
    const [showUploadList, setShowUploadList] = useState(true);

    const { token:
        {
            colorBgContainer,
            borderRadiusLG,
            colorBorder,
            colorPrimary
        },
    } = theme.useToken();

    

    const props = {
        name: 'file',
        multiple: false,
        maxCount: 1,
        showUploadList: {showUploadList},
        beforeUpload: (file) => {
            // Validate file type
            const allowedFileTypes = ['image/png', 'image/jpeg', 'image/jpg'];
            if (!allowedFileTypes.includes(file.type)) {
                openNotificationWithIcon('error', 'Upload failed', 'Only PNG and JPG images are allowed.', 'bottomLeft');
                return Upload.LIST_IGNORE;
            }
                        
            // Validate file size (1MB = 1024 * 1024 bytes)
            const isLt1M = file.size / 1024 / 1024 <= 1;
            if (!isLt1M) {
                openNotificationWithIcon('error', 'Upload failed', 'Image must be smaller than 1MB.', 'bottomLeft');
                return Upload.LIST_IGNORE;
            }

            setFile(file);
            setFileName(file.name);
            return false;
        },
        // action: '/src/assets/image/eSignature',
        // onChange(info) {
        //     const { status } = info.file;
        //     //console.log(status);
        //     if (status !== 'uploading') {
        //         //console.log(info.file, info.fileList);
        //     }
        //     if (status === 'done') {
        //         setFileName(info.file.name);
                
        //         //console.log(info.file.name);
        //         //console.log(info.file.type);
        //         //console.log(info.fileList[0].originFileObj);

        //         // Encode the file using the FileReader API
        //         const reader = new FileReader();
        //         reader.onloadend = () => {
        //             //console.log(reader.result);
        //             setFile(reader.result);
        //             // logs data:<type>;base64,wL2dvYWwgbW9yZ...
        //         };
        //         reader.readAsDataURL(info.fileList[0].originFileObj);

        //         message.success(`${info.file.name} file uploaded successfully.`);
        //     } else if (status === 'error') {
        //         message.error(`${info.file.name} file upload failed.`);
        //     } else if (status === 'removed'){
        //         setFile();
        //         message.success(`${info.file.name} file removed successfully.`);
        //     }
        // },
        onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);
        },
    };

    const saveeSignature = async () => {
        //console.log(file);
        if(file !== undefined ){
            const formData = new FormData();
            formData.append('signature', file);
            await SignatureSettingsAPI.saveeSignature(formData, companyId, token)
            .then((response) => { 
                
                openNotificationWithIcon('success', "Successful", `${response.message}`, 'bottomLeft');
                goBack()
            })
            .catch((err) => {
                if (err.response) {
                    openNotificationWithIcon('error', 'eSignature creation failed', `${err.response.data.message}`, 'bottomLeft');
                } else {
                    openNotificationWithIcon('error', 'eSignature creation failed', `${err.message}`, 'bottomLeft');
                }
            });
        }
        else{
            openNotificationWithIcon('error', 'eSignature creation failed', 'eSignature creation failed', 'bottomLeft');
        }
    };
    
    const cleareSignature = async (e) => {
        setFile();
        setShowUploadList(false);
    }

    const [api, contextHolder] = notification.useNotification();
    const openNotificationWithIcon = (type, message, description, placement) => {
      api[type]({
          message: message,
          description: description,
          placement
      });
    };

    return (
        <>
            <div style={{
                margin: '16px',
                padding: '8px 12px',
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                <Flex justify='space-between' align='center'>
                    <Flex justify='flex-start' align='center' gap={16}>
                        {/* enable this only on mobile size  */}
                        <Button type="text" icon={<LeftOutlined />} onClick={goBack} />
                        <span>Upload New Signature</span>
                    </Flex>
                    {/* <Button type="primary"> Edit </Button> */}
                </Flex>
            </div>

            <div style={{
                margin: '16px',
                padding: '24px 12px',
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                <Dragger {...props} style={{
                    marginTop: 16,
                    marginBottom: 16 
                }}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Click or drag file to this area to upload</p>
                    <p className="ant-upload-hint">
                        Maximum file size: 1MB. Strictly prohibited from uploading company data or other banned files.
                    </p>
                </Dragger>
                <Flex align='center' justify='flex-end' gap={16}>
                    {/* <Button onClick={cleareSignature} type="default">
                        Clear
                    </Button> */}
                    <Button onClick={saveeSignature} type="primary">
                        Save
                    </Button>
                </Flex>
            </div>
            {contextHolder}
        </>
    );
};

export default UploadSignature;
